import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    sessionStorage.setItem(
      "postLoginRedirect",
      location.pathname + location.search
    );
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;